import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { actions } from "store/actions";
import ProjectFilters from "pages/projects/common/ProjectFilters";
import Pagination from "components/pagination";
import DeliverablesPanel from "pages/projects/common/DeliverablesPanel";
import ReferenceFilesPanel from "pages/projects/common/ReferenceFilesPanel";
import TasksTable from "./components/TasksTable";
import useVendorTasks from "./hooks/useVendorTasks";

function FreelancerProjects() {
  const [t] = useTranslation();

  const {
    searchTerm,
    setSearchTerm,

    selectedServices,
    setSelectedServices,
    selectedDeadline,
    setSelectedDeadline,
    serviceOptions,
    tasks,
    totalCount,
    isLoading,
    pagination,
    setFilterQuery,
    handlePageChange,
    clearFilters,
    fetchTasks,
  } = useVendorTasks();

  const [activeTask, setActiveTask] = React.useState(null);
  const [isDeliverablesOpen, setDeliverablesOpen] = React.useState(false);
  const [isReferencesOpen, setReferencesOpen] = React.useState(false);

  const dispatch = useDispatch();

  return (
    <div className="flex w-full h-full p-[24px] flex-col gap-[20px] self-stretch flex-1">
      <div className="flex items-center gap-[12px]">
        <div className="text-[#1D1B22] font-semibold text-[30px]">
          {t("tasksTitle")}
        </div>

        <div className="flex py-[4px] p-[8px] justify-center items-center gap-[2px] rounded-[6px] border border-[#B5C8D6] bg-[#E0E6EB]">
          <div className="text-[#1E4A6B] font-semibold text-[14px] h-[20px]">
            {totalCount}
          </div>
        </div>
      </div>

      <ProjectFilters
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        selectedServices={selectedServices}
        setSelectedServices={setSelectedServices}
        selectedDeadline={selectedDeadline}
        setSelectedDeadline={setSelectedDeadline}
        setFilterQuery={setFilterQuery}
        serviceOptions={serviceOptions}
        disabled={false}
        isVendor={true}
      />

      {/* Tasks Table */}
      <TasksTable
        tasks={tasks}
        isLoading={isLoading}
        viewReferences={(p) => {
          setActiveTask(p);
          setReferencesOpen(true);
        }}
        fetchTasks={fetchTasks}
        uploadDeliverables={(p) => {
          setActiveTask(p);
          setDeliverablesOpen(true);
        }}
      />

      <DeliverablesPanel
        isOpen={isDeliverablesOpen}
        onClose={() => setDeliverablesOpen(false)}
        activeAssignee={activeTask}
      />

      <ReferenceFilesPanel
        isOpen={isReferencesOpen}
        onClose={() => setReferencesOpen(false)}
        files={activeTask?.referenceFile || []}
      />

      {totalCount > pagination.pageSize && (
        <div className="flex justify-end items-end w-full h-full">
          <Pagination
            currentPage={pagination.pageNumber}
            totalPages={Math.ceil(totalCount / pagination.pageSize)}
            onPageChange={handlePageChange}
          />
        </div>
      )}
    </div>
  );
}

export default FreelancerProjects;
